import { render, staticRenderFns } from "./actor-skills.vue?vue&type=template&id=144d8809&scoped=true&"
import script from "./actor-skills.vue?vue&type=script&lang=ts&"
export * from "./actor-skills.vue?vue&type=script&lang=ts&"
import style0 from "./actor-skills.vue?vue&type=style&index=0&id=144d8809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144d8809",
  null
  
)

export default component.exports